







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class EventButton extends Vue {
  @Prop({ required: true })
  private event: string;

  // We define this type validation here because vue-property-decorator infers they Object type if the ts any type is used.
  @Prop({ type: undefined })
  private data: any;

  @Prop()
  private label: string;

  onClick() {
    this.$x.emit(this.event, this.data);
  }
}
